import { useState } from "react";
import { useNotificationStore } from "@/store/useNotificationStore";
import { authClient } from "@/lib/auth-client";
import { NotificationType } from "@/store/useNotificationStore";
import cleverIcon from "@/assets/clever-icon.svg";

interface CleverLoginButtonProps {
  onSuccess?: () => void;
  onError?: (error: string) => void;
  mode?: "login" | "signup";
  label?: string;
}

const CleverLoginButton = ({
  onSuccess,
  onError,
  mode = "login",
  label,
}: CleverLoginButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { showNotification } = useNotificationStore();

  const handleCleverLogin = async () => {
    try {
      setIsLoading(true);
      await authClient.signIn.oauth2({
        providerId: "clever",
        callbackURL: window.location.origin,
      });
      onSuccess?.();
    } catch (error: any) {
      console.error("Clever login error:", error);
      const errorMessage = "Clever login failed";
      showNotification(errorMessage, NotificationType.WARNING);
      onError?.(errorMessage);
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleCleverLogin}
      disabled={isLoading}
      className="w-full flex items-center justify-center px-4 py-3 text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {isLoading ? (
        <span>{mode === "signup" ? "Signing up..." : "Signing in..."}</span>
      ) : (
        <>
          <img src={cleverIcon} alt="Clever" className="w-5 h-5 mr-3 rounded" />
          {label ?? (mode === "signup" ? "Sign up with Clever" : "Clever")}
        </>
      )}
    </button>
  );
};

export default CleverLoginButton;
